module.exports = __webpack_public_path__ + "assets/img/2.ad2db254.png";